import get from "lodash/get";
import { getCategoryDetails } from "./";

export default state => get(getCategoryDetails(state), "headerBody");
